// components/ProposalTemplates.jsx
import React, { useState } from 'react';
import CategoriesTable from './templates/CategoriesTable';
import TemplatesTable from './templates/TemplatesTable';
import AITemplatesPage from './aiTemplates/AITemplatesPage';
import { useNavigate } from 'react-router-dom';

const ProposalTemplates = () => {
  const [activeTab, setActiveTab] = useState('template-segment');
   const navigate = useNavigate();

  const tabs = [
    { id: 'template-segment', label: 'Template Segment' },
    { id: 'templates', label: 'Templates' },
    { id: 'ai-templates', label: 'AI Templates' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'template-segment':
        return <CategoriesTable />;
      case 'templates':
        return <TemplatesTable />;
      case 'ai-templates':
        return <AITemplatesPage />;
      default:
        return <CategoriesTable />;
    }
  };

  return (
    <div className=" p-6">

        <div className="flex w-full mb-8 justify-between items-center">
          <div className='flex items-center gap-3'>
            <button 
              onClick={() => navigate('/dashboard')}
              className="flex items-center justify-center"
            >
              <img src="/Icons/arrow-back.svg" alt="Back" className="w-8 h-8" />
            </button>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Proposal Templates</h1>
            </div>
          </div>
    
        </div>
      {/* Header */}
  
      {/* Tabs */}
      <div className="flex gap-2 mb-6 bg-white p-2 rounded-xl shadow-sm w-full border-2 border-light-blue ">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-2 rounded-lg font-medium transition-all w-1/3 ${
              activeTab === tab.id
                ? 'bg-primary-blue text-white shadow-md'
                : 'bg-light-blue-shade-20 text-primary-blue  hover:bg-gray-50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="bg-white rounded-lg">
        {renderContent()}
      </div>
    </div>
  );
};

export default ProposalTemplates;
